import React from 'react'
import "./analyze.scss"
import { Link } from 'react-router-dom'
import logo from "../../../assets/icons/sitelogoWhite.svg"
const Analyze = () => {
  return (
    <>
    <div className="analyzecontainer">
    <div className="analyzenav">
    <div className="analyzelogo">
      <img src={logo} alt="" />
      <h2>
      Auto Red
      </h2>
    </div>
    <div className="analyzelogin">
      <div className='analyzelog'>
        <p>
          Login
        </p>
      </div>
      <div className='analyzesignup'>
      <p>
          Sign Up
        </p>
      </div>
    </div>
   </div>
    </div>
 

    <div className='analyze'>
      <div className="logo">

      </div>
      <div className="analyzehead">
        <h2>
          Compare your brand with others and Uncover the Competitive Landscape
        </h2> </div>
      <div className="aibtn">
        <Link to="/chatbot"><button>
          Start with AI
        </button></Link>
      </div>
    </div>
    </>
  )
}

export default Analyze
